import React, { Fragment, useState, useCallback, useMemo } from "react";
import styles from "./MMScreenInputViews.module.css";
import { TableContainer, Table } from "@mui/material";
import { useDailyPhasingContext } from "../../../../../utils/dailyphaisngContext/DailyphasingContext";
import { useInfiniteScrollData } from "Samarth Module/pages/dailyPhasing/hooks/useInfiniteScrollData";

import TblHeader from "./TblHeader";
import TblBody from "./TblBody";
import TblFooter from "./TblFooter";

const MMScreenView = () => {
    const { tableDataColumns, filteredTableData } = useDailyPhasingContext();
    const { data, containerRef } = useInfiniteScrollData(filteredTableData, 30);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const requestSort = useCallback((key) => {
        setSortConfig(prev => ({
            key,
            direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
        }));
    }, []);

    const sortedData = useMemo(() => {
        if (!sortConfig.key || !data.length) return data;

        return [...data].sort((a, b) => {
            const valueA = a[sortConfig.key];
            const valueB = b[sortConfig.key];

            if (!isNaN(valueA) && !isNaN(valueB)) {
                return sortConfig.direction === "asc" ? valueA - valueB : valueB - valueA;
            }

            if (typeof valueA === "string" && typeof valueB === "string") {
                return sortConfig.direction === "asc"
                    ? valueA.localeCompare(valueB)
                    : valueB.localeCompare(valueA);
            }

            return 0;
        });
    }, [data, sortConfig]);

    return (
        <Fragment >
            <Fragment>
                <TableContainer
                    className={styles.table}
                    sx={{ flex: 1, overflow: "auto" }}
                    ref={containerRef}
                >
                    <Table size="small">
                        <TblHeader
                            columns={tableDataColumns}
                            requestSort={requestSort}
                            sortConfig={sortConfig}
                        />
                        <TblBody
                            columns={tableDataColumns}
                            body={sortedData}
                            isActionable={false}
                        />
                        <TblFooter
                            columns={tableDataColumns}
                            footerColums={["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Total", "SAP weekly plan", "Plan Chg(AERA)", "Actuals"]}
                            exeColms={["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "SAP weekly plan", "Plan Chg(AERA)", "Actuals"]}
                            data={filteredTableData}
                            isActionable={false}
                        />

                    </Table>
                </TableContainer>
            </Fragment>
        </Fragment>
    );
};

export default React.memo(MMScreenView);
